/* eslint-disable react/no-danger */
import React from 'react';

import styles from './index.module.css';

export const HtmlRenderer = ({ text }) => (
    <div className={ styles.renderer } dangerouslySetInnerHTML={ { __html: text } } />
);
